import { create } from "zustand";
import { Book } from "../libs/types";

/** Create-book form draft (Book without id) for persistence while editing */
export type CreateBookDraft = Omit<Book, "id">;

interface BookState {
  // State
  currentBook: Book | Book[] | null;
  isPreview: boolean;
  /** Form data to restore when returning from preview (Close preview) */
  restoreForm: Book | null;
  /** Draft form data while working in CreateBook; cleared on Save/Publish */
  createBookDraft: CreateBookDraft | null;

  // Actions
  setBook: (book: Book | Book[]) => void;
  setPreviewMode: (value: boolean) => void;
  setRestoreForm: (book: Book | null) => void;
  setCreateBookDraft: (draft: CreateBookDraft | null) => void;
  clearCreateBookDraft: () => void;
  clearBook: (opts?: { preserveRestoreForm?: boolean }) => void;
  resetState: () => void;
}

export const useBookStore = create<BookState>((set) => ({
  currentBook: null,
  isPreview: false,
  restoreForm: null,
  createBookDraft: null,

  setBook: (book: Book | Book[]) =>
    set({
      currentBook: book,
      isPreview: Array.isArray(book)
        ? book[0]?.id === "preview"
        : (book as Book).id === "preview",
    }),

  setPreviewMode: (value: boolean) => set({ isPreview: value }),

  setRestoreForm: (book: Book | null) => set({ restoreForm: book }),

  setCreateBookDraft: (draft: CreateBookDraft | null) =>
    set({ createBookDraft: draft }),
  clearCreateBookDraft: () => set({ createBookDraft: null }),

  clearBook: (opts?: { preserveRestoreForm?: boolean }) =>
    set((prev) => ({
      currentBook: null,
      isPreview: false,
      ...(opts?.preserveRestoreForm ? {} : { restoreForm: null }),
    })),

  resetState: () =>
    set({
      currentBook: null,
      isPreview: false,
      restoreForm: null,
      createBookDraft: null,
    }),
}));
